import React from "react";

const PrivacyPolicy = () => {
    const htmlContent = `
        
    <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Last Updated: 09/
    24 / 2025 </p><h2 style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Introduction</h2> <p
    style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;"> Thermal
    Solutions
    Products, LLC(the “Company” or “we”)
    respects
    your
    privacy
    and
    we
    are
    committed
    to
    protecting
    it
    through
    our
    compliance
    with this policy.
</p>
    <p style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">This policy
        describes the types of information we may collect from you or that you may provide when you visit our website
        boiler-connect.com (our “Website”), when you register your product, or when you download, install, register
        with, access, or use the Boiler-Connect App mobile device application (the “App”) and our practices for
        collecting, using, maintaining, protecting, and disclosing that information.</p>
    <p style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">This policy applies to information we collect:</p>
    <ul id="l1">
        <li data-list-text=""><p>
        On this Website;</p></li>
        <li data-list-text=""><p>Through the App; and</p>
        </li>
        <li data-list-text=""><p>In email,
            text, and other electronic messages between you and this Website and App. It does not apply to information
            collected:</p></li>
        <li data-list-text=""><p>Offline or through any
            other means, including on any other website or mobile application operated by the Company or any third party
            (including our affiliates and subsidiaries);</p></li>
        <li data-list-text=""><p>About
            current, former, or prospective employees or contractors outside of California;</p></li>
        <li data-list-text=""><p>About any
            individual, party, or entity outside of California with whom we have only a business-to-business or
            commercial relationship; or</p></li>
        <li data-list-text=""><p>From any
            third party (including our affiliates and subsidiaries), including through any application or content
            (including advertising) that may link to or be accessible from or on the Website or App.</p>
        </li>
        </ul>    
            <p
            style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">
        
            Please read this policy carefully to understand our policies and practices regarding your information and how we will
            treat it. If you do not agree with our policies and practices, your choice is not to use our Website and
            App. By accessing or using our Website or App, you agree to this privacy policy.</p><p
            style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">This policy
            may change from time to time. Your continued use of this Website or our App after we make changes is deemed
            to be acceptance of those changes, so please check the policy periodically for updates.</p>
            
    <h2 style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Information We Collect About
    You and How We Collect It</h2>
    <p className="s1" style="padding-top: 9pt;padding-left: 41pt;text-indent: 0pt;text-align: left;"><b>Types
    of Information We Collect</b></p><p
    style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 107%;text-align: left;">We collect
    several types of information from and about users of our Website and App, including information:</p>
        <ul>
        <li data-list-text=""><p>That
            personally identifies you, or that identifies, relates to, describes, is reasonably capable of being
            associated with, or could be reasonably be linked, directly or indirectly, with you or your household.
            This may include but is not necessarily limited to information, such as your name, company address, email
            address, telephone number, job title, employer name, location data, or any other identifier by which you may
            be contacted online or offline (&quot;<b>Personal Information</b>&quot;);</p></li>
        <li data-list-text=""><p>That is
            about you but individually does not identify you, such as company name, company address, or the products of
            ours that you have purchased or used;</p></li>
        <li data-list-text=""><p>Stored
            and live data about the Boiler system you are installing, monitoring, configuring, and maintaining (“Boiler
            Data”) that is broadcast to us through the App; and/or</p></li>
        <li data-list-text=""><p>About
            your internet connection, the equipment you use to access our Website and/or App, and usage details.</p>
            <p className="s1" style="padding-top: 7pt;padding-left: 23pt;text-indent: 0pt;text-align: left;"><b>How We Collect
            Your Information</b>
            </p>
        </li>
        </ul>
        <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">We
            collect this information:</p>
        <ul>    
        <li data-list-text=""><p>Directly from you when you
            provide it to us.</p></li>
        <li data-list-text=""><p>Automatically
            as you navigate through and use the Website and App. Information collected automatically may include usage
            details, IP addresses, Boiler Data, and information collected through cookies, web beacons, and other
            tracking technologies.</p>
        </li>
        </ul>
            <p
            style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">We collect information from
            and about users of our App:</p>
        <ul>
        <li data-list-text=""><p>Directly from you when you
            provide it to us.</p></li>
        <li data-list-text=""><p>Automatically when you use
            the App.</p>
        </li>
        </ul>    
            <p className="s1" style="padding-top: 9pt;padding-left: 23pt;text-indent: 0pt;text-align: left;">
            <b>Information You Provide to Us </b></p><p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">The
            information we collect on or through our Website and/or App may include:</p>
        <ul>
        <li data-list-text=""><p>Information
            that you provide by filling in forms on our Website and/or App. This includes information provided at the
            time of registering to use our Website and/or App, registering a product, requesting to contact or be
            contacted by a contractor or technician, signing up for our mail or email lists, or requesting further
            services. We may also ask you for information when you report a problem with our Website and/or App.</p>
        </li>
        <li data-list-text=""><p>Records and copies of your
            correspondence (including email addresses) if you contact us.</p></li>
        <li data-list-text=""><p>Your
            responses to surveys that we might ask you to complete for research purposes.</p></li>
        <li data-list-text=""><p>Your
            search queries on the Website.</p>
        </li>
        </ul>    
        <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 107%;text-align: left;">When you
            download, register with, or use the Website and/or App, we may ask you to provide information:</p>
        <ul>    
        <li data-list-text=""><p>By which
            you may be personally identified, such as name, company postal address, email address, telephone number, or
            any other information the Website and/or App collects that is defined as Personal Information or personally
            identifiable information under an applicable law.</p></li>
        <li data-list-text=""><p>About
            your location and the location of your device. We use this information to determine the address of the
            boiler being diagnosed with the App.</p></li>
        <li data-list-text=""><p>That is
            about you but individually does not identify you, such as the Boiler systems and other products you have
            serviced in the past.</p>
        </li>
        </ul>    
        <p className="s1" style="padding-top: 7pt;padding-left: 41pt;text-indent: 0pt;text-align: left;"><b>Information
            We Collect Through Automatic Data Collection Technologies</b></p><p
            style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">As you
            navigate through and interact with our Website, we may use automatic data collection technologies to collect
            certain information about your equipment, browsing actions, and patterns, including:</p>
        <ul>    
        <li data-list-text=""><p>Details
            of your visits to our Website, including traffic data, logs, and other communication data and the resources
            that you access and use on the Website.</p></li>
        <li data-list-text=""><p>Information
            about your computer and internet connection, including your IP address, operating system, and browser
            type.</p>
        </li>
        </ul>    
            <p style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">When you download,
            access, and use the App, it may use technology to automatically collect:</p>
        <ul>    
        <li data-list-text=""><p>Details
            of your access to and use of the App, including location data, logs, and other communication data and the
            resources that you access and use on or through the App.</p></li>
        <li data-list-text=""><p>Information
            about your mobile device and internet connection, including the device&#39;s unique device identifier, IP
            address, operating system, browser type, mobile network information, and the device&#39;s telephone
            number.</p>
        </li>
        </ul>  
        <p style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">The
            information we collect automatically may include Personal Information, or we may maintain or associate it
            with other Personal Information we collect. It helps us to improve our Website and App and to deliver a
            better and more personalized service, including by enabling us to:</p>
        <ul>
        <li data-list-text=""><p>Estimate our audience size
            and usage patterns.</p></li>
        <li data-list-text=""><p>Store
            information about your preferences, allowing us to customize our Website and App according to your
            individual interests.</p></li>
        <li data-list-text=""><p>Speed
            up your searches.</p></li>
        <li data-list-text=""><p>Recognize you when you
            return to our Website or App.</p>
        </li>
        </ul>
            <p
            style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">The technologies we use for
            this automatic data collection may include:</p>
        <ul>    
        <li data-list-text=""><p><b>Cookies
            (or browser and mobile cookies).</b> <span className="p">A cookie is a small file placed on the storage of your device. You may refuse to accept browser cookies by activating the appropriate setting on your browser. It may also be possible to refuse to accept mobile cookies by activating the appropriate setting on your smartphone or device. However, if you select this setting, you may be unable to access certain parts of our Website or the App.</span>
        </p></li>
        <li data-list-text=""><p><b>Web
            Beacons.</b> <span className="p">Pages of our Website and the App and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages and for other</span>
        related
            Website and App statistics (for example, recording the popularity of Website and App content and verifying
            system and server integrity).</p>
        </li>
        </ul>    
            <h2
            style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">How We Use Your
            Information</h2><p
            style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 107%;text-align: left;">We use
            information that we collect about you or that you provide to us, including any Personal Information:</p>
        <ul>
        <li data-list-text=""><p>To
            present our Website and App and their contents to you.</p></li>
        <li data-list-text=""><p>To
            provide you with information, products, or services that you request from us, including putting you in
            contact with partners and subcontractors.</p></li>
        <li data-list-text=""><p>To
            fulfill any other purpose for which you provide it.</p></li>
        <li data-list-text=""><p>To carry
            out our obligations and enforce our rights arising from any contracts entered into between you and us,
            including for billing and collection.</p></li>
        <li data-list-text=""><p>To notify
            you about changes to our Website or App or any products or services we offer or provide though it.</p></li>
        <li data-list-text=""><p>To
            estimate our audience size and usage patterns.</p></li>
        <li data-list-text=""><p>To store
            information about your preferences, allowing us to customize our App and Website according to your
            individual interests.</p></li>
        <li data-list-text=""><p>To
            speed up your searches.</p></li>
        <li data-list-text=""><p>To
            recognize you when you use the App and Website.</p></li>
        <li data-list-text=""><p>To
            notify you when App updates are available.</p></li>
        <li data-list-text=""><p>In
            any other way we may describe when you provide the information.</p></li>
        <li data-list-text=""><p>For
            any other purpose with your consent.</p>
        </li>
        </ul>    
            <p
            style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">We use
            Boiler Data and location information to assist you in registering your products with us, to provide customer
            and technical support, and to help contractors and technicians service those products being diagnosed with
            the App.</p><h2 style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Disclosure of
            Your Information</h2><p
            style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">We do not
            sell your Personal Information to unaffiliated third parties. We may share Personal Information with our
            affiliates in exchange for the marketing of our products and services to their customers. This may be
            considered a “sale” in certain jurisdictions. The categories of Personal Information we share may
            include:</p>
        <ul>
        <li data-list-text=""><p>Identifiers such as your
            name, company address, email address, telephone number, job title, and employer name;</p></li>
        <li data-list-text=""><p>Internet or network
            activity; or</p></li>
        <li data-list-text=""><p>Geolocation data.</p>
        
        </li>
        </ul>
            <p style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">We may
                disclose aggregated information about our users, and information that does not identify any individual,
                without restriction.</p><p
                style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">We may disclose Personal
                Information that we collect or you provide as described in this privacy policy:</p>
        <ul>
        <li data-list-text=""><p>To
            our subsidiaries and affiliates.</p></li>
        <li data-list-text=""><p>To
            contractors, service providers, and other third parties we use to support our business.</p></li>
        <li data-list-text=""><p>To a
            buyer or other successor in the event of a merger, divestiture, restructuring, reorganization, dissolution,
            or other sale or transfer of some or all of the Thermal Solutions Products, LLC’s assets, whether as a going
            concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Information held by
            the Company about our Website or App users is among the assets transferred.</p></li>
        <li data-list-text=""><p>To
            fulfill the purpose for which you provide it.</p></li>
        <li data-list-text=""><p>For
            any other purpose disclosed by us when you provide the information.</p></li>
        <li data-list-text=""><p>With
            your consent.</p>
        </li>
        </ul>    
        <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">We may
        also disclose your Personal Information:</p>
        <ul>
        <li data-list-text=""><p>To comply
            with any court order, law, or legal process, including responding to any government or regulatory
            request.</p>
        <li data-list-text=""><p>To
            enforce or apply our terms &amp; conditions and other agreements, including for billing and collection
            purposes.</p></li>
        <li data-list-text=""><p>If we
            believe disclosure is necessary or appropriate to protect the rights, property, or safety of the Company,
            our customers, or others.</p>
        </li>
        </ul>    
            <h2
            style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Choices About How We Use and
            Disclose Your Information</h2><p
            style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 107%;text-align: left;">We strive to
            provide you with choices regarding the personal information you provide to us. We have created mechanisms to
            provide you with the following control over your information:</p>
        <ul>    
        <li data-list-text=""><p><b>Tracking
            Technologies.</b><span className="p">You can set your browser or device to refuse all or some cookies, or to alert you when cookies are being sent. You can choose whether or not to allow the App to collect information through other tracking technologies by disabling (or enabling) the appropriate settings on your device. If you disable or refuse cookies or block the use of other tracking technologies, some parts of the App may then be inaccessible or not function properly.</span>
        </p></li>
        <li data-list-text=""><p><b>Location Information.</b> <span className="p">You can choose whether or not to allow the App to collect and use real-time information about your device&#39;s location through the device&#39;s privacy settings or from within the App. If you block the use of location information, some parts of the App may become inaccessible or not function properly.</span>
        </p>
        </li>
        </ul>
        <h2 style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Retention</h2><p
            style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">We will
            retain your Personal Information for as long as it is necessary to comply with our data retention
            requirements, to provide you with the services you expect and request from us, and for your safety if</p><p
            style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">you need to
            be contacted about one of our products. If you submit a deletion request, we may be required to maintain
            your Personal Information as long as necessary to:</p>
        <ul>
        <li data-list-text=""><p>Comply with our legal or
            regulatory compliance needs;</p></li>
        <li data-list-text=""><p>To exercise,
            establish, or defend legal claims; and/or</p></li>
        <li data-list-text=""><p>To protect against
            fraudulent or abusive activity affecting our services or business operations.</p>
        </li>
        </ul>    
            <p
            style="padding-top: 9pt;text-indent: 0pt;text-align: left;">
            
            </p><h2
            style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Your Rights Under State Privacy Laws</h2><p
            style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">Depending on
            your location and applicable laws, you may have certain rights regarding your personal information,
            including:</p><p className="s2"
                             style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;"><b>The
            Right to Know and to Confirm</b><span className="p">. You may have the right to request that we disclose certain information to you about our collection and use of your Personal Information over the past 12 months (the “right to know” and the “right to confirm”). Once we receive your request and confirm your identity, and as required by law, we will disclose to you:</span>
        </p>
        <ul>
        <li data-list-text=""><p>The
            categories of Personal Information that we collected about you.</p></li>
        <li data-list-text=""><p>The
            categories of sources for the Personal Information we collected about you.</p></li>
        <li data-list-text=""><p>Our
            business or commercial purpose for collecting or selling that Personal Information.</p></li>
        <li data-list-text=""><p>The categories of
            third parties with whom we share that Personal Information.</p></li>
        <li data-list-text=""><p>If we sold or
            disclosed your Personal Information for a business purpose, two separate lists disclosing:</p>
            <ul id="l2">
                <li data-list-text="o"><p>Sales,
                    identifying the Personal Information categories that each category of recipient purchased; and</p>
                </li>
                <li data-list-text="o"><p>Disclosures
                    for a business purpose, identifying the Personal Information categories that each category of
                    recipient obtained.</p>
                    <p style="text-indent: 0pt;text-align: left;"><br/></p>
                </li>
            </ul>        
        </li>
        </ul>            
                    <p className="s2"                                                                                                 style="padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                    <b>The
                    Right to Data Portability.</b> <span className="p">If you submit a data portability request, we will provide you with a copy of your Personal Information in a common and portable format that you may transfer to another organization of your choosing.</span>
                </p><p className="s2"
                       style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;"><b>The
                    Right to Delete.</b> <span className="p">You may have the right to request that we delete any of your Personal Information that we collected from you and retained, subject to certain exceptions (the &quot;right to delete&quot;). Once we receive your request and confirm your identity, and as required by applicable law, we will review your request to see if an exception allowing us to retain the information applies. We may deny your deletion request if retaining the information is necessary for us or our service provider(s) to fulfill a lawful purpose.</span>
                </p><p
                    style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">We
                    will delete or deidentify Personal Information not subject to one of these exceptions from our
                    records and will direct any of our service providers to take similar action where required by
                    applicable law.</p><p className="s2"
                                          style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;"><b>The
                    Right to Correct Inaccurate Information.</b> <span className="p">You may have the right to correct any inaccurate Personal Information about you that we have in our possession (the “right to correct”). Once we receive your request and confirm your identity, and as required by applicable law, we will disclose to you the specific pieces of Personal Information that we have collected about you. You will then have the opportunity to direct us to correct the pieces of information which you believe are inaccurate.</span>
                </p><p
                    style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">We
                    may deny your request to correct if we believe the updated information is incorrect or is being used
                    for any fraudulent or deceptive purpose.</p><p
                    style="padding-top: 7pt;text-indent: 0pt;text-align: left;"></p><p className="s2"
                                                                                            style="padding-left: 5pt;text-indent: 0pt;text-align: left;"><b>The
                    Right to Restrict Sensitive Personal Information Processing.</b> <span className="p">You may have the right to</span>
                </p><p
                    style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">restrict
                    our processing of your sensitive personal information (the “right to restrict”). Once we receive
                    your request and verify your identity, and as required by applicable law, we will cease the
                    processing of your sensitive personal information for the purpose of inferring characteristics about
                    you. Please note that we may continue to process your sensitive personal information for other
                    purposes consistent with this Privacy Policy.</p><p
                    style="padding-top: 7pt;text-indent: 0pt;text-align: left;"><br/></p><p className="s2"
                                                                                            style="padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;"><b>The
                    Right to Be Free from Discrimination.</b> <span className="p">We will not discriminate against you for exercising any of your rights under applicable state privacy law. Unless permitted by state law, we will not discriminate against you for exercising rights you are afforded under applicable law.</span>
                </p><p style="text-indent: 0pt;text-align: left;"><br/></p><p className="s2"
                                                                              style="padding-left: 5pt;text-indent: 0pt;text-align: left;"><b>The
                    Right to Opt Out.</b> <span className="p">You have the right to opt out of Personal Information processing for:</span>
                </p>
        <ul>    
        <li data-list-text=""><p>Targeted advertising;</p>
        </li>
        <li data-list-text=""><p
           >Sales; or</p></li>
        <li data-list-text=""><p>Profiling in furtherance
            of decisions that produce legal or similarly significant effects.</p></li>
       </ul>
    <h2 style="padding-top: 12pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Response Timing and
        Procedure</h2>
    <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: justify;">We will
        confirm receipt of your request within ten (10) business days. If you do not receive confirmation within the
        10-day timeframe, please email <a href="mailto:PrivacyPolicy@thermalsolutions.com" className="a"
                                          target="_blank">PrivacyPolicy@thermalsolutions.com</a> or call 717-239-7642.
    </p>
    <p style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: justify;">We endeavor to
        substantively respond to a verifiable consumer request within forty-five (45) days of its receipt. If we require
        more time (up to another 45 days), we will inform you of the reason and extension period in writing.</p>
    <p style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">If you have an
        account with us, we may deliver our written response to that account. Alternatively, or if you do not have an
        account with us, we will deliver our written response by mail or electronically, at your option.</p>
    <p style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">Any disclosures
        we provide will only cover the 12-month period preceding our receipt of your request. The response we provide
        will also explain the reasons we cannot comply with a request, if applicable. For data portability requests, we
        will select a format to provide your Personal Information that is readily useable and should allow you to
        transmit the information from one entity to another entity without hindrance.</p>
    <p style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">We do not charge
        a fee to process or respond to your verifiable consumer request unless it is excessive, repetitive, or
        manifestly unfounded. If we determine that the request warrants a fee, we will tell you why we made that
        decision and provide you with a cost estimate before completing your request.</p>
    <h2 style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Accessing and Correcting Your
        Information</h2>
    <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">You can review
        and change your personal information by logging into the Website or App and visiting your account profile
        page.</p>
    <p style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">You may also send
        us an email at <a href="mailto:PrivacyPolicy@thermalsolutions.com" className="a"
                          target="_blank">PrivacyPolicy@thermalsolutions.com</a> to request access to, correct or delete
        any personal information that you have provided to us. We cannot delete your personal information except by also
        deleting your user account. We may not accommodate a request to change information if we believe the change
        would violate any law or legal requirement or cause the information to be incorrect.</p>
    <h2 style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Children Under the Age of 18</h2>
    <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">The Website and
        App is not intended for children under 18 years of age, and we do not knowingly collect personal information
        from children under 18. If we learn we have collected or received personal information from a child under 18
        without verification of parental consent, we will delete that information. If you believe we might have any
        information from or about a child under 18, please contact us at <a
            href="mailto:PrivacyPolicy@thermalsolutions.com" className="a"
            target="_blank">PrivacyPolicy@thermalsolutions.com</a>.</p>
    <h2 style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Data Security</h2>
    <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">We have
        implemented reasonable measures designed to secure your Personal Information from accidental loss and from
        unauthorized access, use, alteration, and disclosure.</p>
    <p style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">The safety and
        security of your Personal Information also depends on you. Where we have given you (or where you have chosen) a
        password for access to certain parts of our App or Website, you are responsible for keeping this password
        confidential. We ask you not to share your password with anyone.</p>
    <p style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">Unfortunately,
        the transmission of information via the internet and mobile platforms is not completely secure. Although we do
        our best to protect your Personal Information, we cannot guarantee the security of your Personal Information
        transmitted through our App or to our Website. Any transmission of Personal Information is at your own risk. We
        are not responsible for circumvention of any privacy settings or security measures we provide.</p>
    <h2 style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Changes to Our Privacy Policy</h2>
    <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">It is our policy
        to post any changes we make to our privacy policy on this page. If we make material changes to how we treat our
        users&#39; Personal Information, we will notify you through a notice on the Website home page or within the App.
        The date the privacy policy was last revised is identified at the top of the page. You are responsible for
        periodically visiting this privacy policy to check for any changes.</p>
    <h2 style="padding-top: 8pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Contact Information</h2>
    <p style="padding-top: 9pt;padding-left: 5pt;text-indent: 0pt;line-height: 168%;text-align: left;">To ask questions
        or comment about this privacy policy and our privacy practices, contact us at: <a
            href="mailto:PrivacyPolicy@thermalsolutions.com">PrivacyPolicy@thermalsolutions.com</a> or via our number: 717-239-7642</p>
  `;

    return (
        <div
            className="privacy-policy"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    );
};

export default PrivacyPolicy;
